<template>
    <button @click="reset()" type="button" class="btn btn-sm btn-success btn-block">
        <li class="fa fa-recycle"></li> ENVIAR PROTOCOL 18
    </button>
</template>
<script>
    import {Bus} from '../../class/bus';
    import {Tk} from '../../class/tk';
    export default {
        props: {
            id_rastreador: {
                "default": null
            }
        },
        methods: {
            async reset () {
                await Tk.sendProtocol18(this.id_rastreador);
                Bus.$emit('comandos');
            }
        }
    }
</script>
